import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './PasswordResetSuccessPage.css';

function PasswordResetSuccessPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Auto-redirect to login after 10 seconds
    const timer = setTimeout(() => {
      navigate('/');
    }, 10000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="password-reset-success-page">
      <div className="success-container">
        <div className="success-icon-large">✓</div>
        
        <h1>Password Reset Successful!</h1>
        
        <p className="success-description">
          Your password has been successfully reset. You can now log in with your new password.
        </p>

        <div className="success-info">
          <div className="info-item">
            <span className="info-icon">🔒</span>
            <span>Your account is now secured with your new password</span>
          </div>
          <div className="info-item">
            <span className="info-icon">📧</span>
            <span>A confirmation email has been sent to your inbox</span>
          </div>
          <div className="info-item">
            <span className="info-icon">⏱️</span>
            <span>Redirecting to login page in 10 seconds...</span>
          </div>
        </div>

        <div className="success-actions">
          <button 
            onClick={() => navigate('/')}
            className="login-now-button"
          >
            Login Now
          </button>
        </div>

        <div className="security-reminder">
          <h3>Security Reminders:</h3>
          <ul>
            <li>Never share your password with anyone</li>
            <li>Use different passwords for different accounts</li>
            <li>Enable two-factor authentication when available</li>
            <li>Report any suspicious activity to HR immediately</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default PasswordResetSuccessPage;